export default __webpack_public_path__ + "static/media/baff.574b5992.png";